import { Avatar } from "PFComponents/avatar";
import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { ProfileAvatar } from "PFComponents/profile_avatar/profile_avatar";
import { getProfileName } from "PFCore/helpers/profile";
import { useUnbiasedProfileName } from "PFCore/hooks/use_unbiased_profile_name";
import { IconName } from "PFTheme/graphics/icons";
import { CustomTypes, Profile } from "PFTypes";
import { SyntheticEvent } from "react";

import { SuspendedPill } from "../../suspended_pill";
import { Headline } from "./headline";
import ProfileCardName from "./profile_card_name";
import css from "./profile_card_title.module.scss";

type Props = {
  avatarSize: number;
  customTypes: CustomTypes;
  href?: string;
  handleClick?: () => void;
  handleIconClick?: (e: SyntheticEvent) => void;
  icon?: IconName;
  isUnbiasedMode?: boolean;
  onAvatarClick?: (e: SyntheticEvent) => void;
  profile: Profile;
};

const ProfileCardTitle = ({
  avatarSize,
  customTypes,
  href,
  handleClick,
  handleIconClick,
  isUnbiasedMode,
  profile,
  onAvatarClick,
  icon
}: Props) => {
  const { getUnbiasedProfileName } = useUnbiasedProfileName();
  const name = getProfileName(profile);

  const onClick: (ev: SyntheticEvent) => void = (event) => {
    event.preventDefault();
    if (handleClick) {
      handleClick();
    }
  };

  return (
    <div className={css.title}>
      <div className={css.avatar}>
        {isUnbiasedMode ? (
          <Avatar
            size={avatarSize || 80}
            backgroundColor="#ffc0cb"
            text={getUnbiasedProfileName(profile, isUnbiasedMode)}
          />
        ) : (
          <ProfileAvatar
            profile={profile}
            size={avatarSize || 80}
            icon={icon}
            onClick={onAvatarClick}
            handleIconClick={handleIconClick}
          />
        )}
      </div>

      <div className={css.info}>
        <Inline>
          <ProfileCardName
            href={href}
            isUnbiasedMode={isUnbiasedMode}
            profile={profile}
            name={name}
            onClick={onClick}
          />
          {profile.placeholder && <Icon name="placeholder-profile" size="lg" />}
        </Inline>
        {!!profile.suspendedAt && <SuspendedPill suspendedAt={profile.suspendedAt} />}
        {customTypes && (
          <span className={css.headline} data-qa-id="ProfileCard.info">
            <Headline profile={profile} customTypes={customTypes} />
          </span>
        )}
      </div>
    </div>
  );
};

export default ProfileCardTitle;
